// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-detail-container {
    display: flex;
    flex-direction: column;
}

.account-navigation-container {
    flex: 0 1 auto;
}

    .account-navigation-container > .signed-out {
        display: flex;
        justify-content: end;
        gap: 0.5rem;
    }

    .account-navigation-container button {
        width: fit-content;
    }

.account-profile-container {
    flex: 0 1 auto;
    height: fit-content;
}

.account-content-container {
    flex: 1 1 auto;
    min-height: 12rem;
}

.account-setting-container {
    flex: 0 1 auto;
}

.account-settings-container {
    display: flex;
    justify-content: end;
}

.library-item-list-container {
    display: flex;
    flex-direction: row;
    padding: 0.25rem;
    gap: 0.25rem;
    overflow-x: auto;
    width: 100%;
}

.library-item {
    height: 5rem;
    aspect-ratio: 1.777;
    background-color: lightgray;
}
`, "",{"version":3,"sources":["webpack://./src/Account/css/AccountDetail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;IAEI;QACI,aAAa;QACb,oBAAoB;QACpB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;AAEJ;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;AAC/B","sourcesContent":[".account-detail-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.account-navigation-container {\r\n    flex: 0 1 auto;\r\n}\r\n\r\n    .account-navigation-container > .signed-out {\r\n        display: flex;\r\n        justify-content: end;\r\n        gap: 0.5rem;\r\n    }\r\n\r\n    .account-navigation-container button {\r\n        width: fit-content;\r\n    }\r\n\r\n.account-profile-container {\r\n    flex: 0 1 auto;\r\n    height: fit-content;\r\n}\r\n\r\n.account-content-container {\r\n    flex: 1 1 auto;\r\n    min-height: 12rem;\r\n}\r\n\r\n.account-setting-container {\r\n    flex: 0 1 auto;\r\n}\r\n\r\n.account-settings-container {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n.library-item-list-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding: 0.25rem;\r\n    gap: 0.25rem;\r\n    overflow-x: auto;\r\n    width: 100%;\r\n}\r\n\r\n.library-item {\r\n    height: 5rem;\r\n    aspect-ratio: 1.777;\r\n    background-color: lightgray;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
